import React from 'react';
import { PortalContext } from '../../../../context/PortalContext';
import { actionRedirect } from '../../../../helpers/common-helpers';
import { HuchaTier } from '../models/hucha-values';
import { useHuchaTracker } from './use-hucha-tracker';

export const useCitaHandler = (huchaTier: HuchaTier) => {
	const { userInteractionService } = React.useContext(PortalContext);
	const { trackCitaConcesionarioClick } = useHuchaTracker(huchaTier);

	const handleCita = () => {
		trackCitaConcesionarioClick();
		actionRedirect(userInteractionService, 'es-oneform--lead-cita');
	};
	return { handleCita };
};
